import { openUniDirectionalChannel } from '../utils';
import { OPEN_ENTITY_DETAILS } from '../constants';
var openEntityDetails = params => {
  openUniDirectionalChannel({
    type: OPEN_ENTITY_DETAILS,
    payload: params
  });
};
export default openEntityDetails;